import { useModal } from 'components/modal/modal.service'
import useOverlay from 'components/overlay/overlay.service'
import { ITabItem } from 'components/tab/tab.interface'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ContactListDataDummy } from './contact-list.dummy'
import Button from 'components/button/button.component'
import { IContactList } from './contact-list.interface'

const useContactList = () => {
    const navigate = useNavigate()

    // overlay
    const filterOverlayService = useOverlay()

    // modal
    const createModalService = useModal()
    const editModalService = useModal()
    const previewModalService = useModal()
    const removeModalService = useModal()

    // state
    const [data, setData] = useState<IContactList[]>(ContactListDataDummy)
    const [detailData, setDetailData] = useState<IContactList>()
    const [loading, setLoading] = useState<boolean>(false)
    const [errorMessage, setErrorMessage] = useState<string | undefined>()
    const [tabItems, setTabItems] = useState<ITabItem[]>()
    const [tabFilter, setTabFilter] = useState<ITabItem>({
        label: 'Active',
        totalData: ContactListDataDummy.filter(
            (x: any) => x.status === 'active',
        ).length,
        key: 'status',
        value: 'active',
        className: 'brand',
    })

    // get data quotations
    useEffect(() => {
        loadData()
    }, [tabFilter])

    // Get Data Function
    const loadData = async () => {
        try {
            setLoading(true)
            const filterData = ContactListDataDummy.filter(
                (x) => x.status === tabFilter.value,
            )
            setData(filterData)
            setLoading(false)
        } catch (e) {
            setLoading(false)
            const errorMessage = typeof e !== 'string' ? 'Something wrong' : e
            setErrorMessage(errorMessage)
        }
    }

    const importDataButton = <Button label="Import Data" onClick={() => {}} />

    return {
        filterOverlayService,
        createModalService,
        editModalService,
        previewModalService,
        removeModalService,
        tabItems,
        tabFilter,
        data,
        detailData,
        loading,
        errorMessage,
        importDataButton,
        setData,
        setDetailData,
        setLoading,
        setErrorMessage,
        navigate,
        setTabFilter,
        setTabItems,
    }
}

export default useContactList
